import Navigation from './components/Navigation';
import Hero from './components/Hero';
import SocialProof from './components/SocialProof';
import Scarcity from './components/Scarcity';
import HowItWorks from './components/HowItWorks';
import ValueProposition from './components/ValueProposition';
import Pricing from './components/Pricing';
import Philosophy from './components/Philosophy';
import TrustLegal from './components/TrustLegal';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-black text-white font-['Inter',sans-serif]">
      <Navigation />
      <Hero />
      <SocialProof />
      <Scarcity />
      <HowItWorks />
      <ValueProposition />
      <Pricing />
      <Philosophy />
      <TrustLegal />
      <FinalCTA />
      <Footer />
    </div>
  );
}
